import { Zap, UserCheck, CheckSquare, Mail, BellRing, FileText, Bell } from "lucide-react";
import { Container, Reveal, SectionHeader } from "./common";

const recipes = [
    {
        name: "New lead fast-response",
        active: true,
        steps: [
            { type: "WHEN", icon: Zap, text: "New lead created", accent: true },
            { type: "THEN", icon: UserCheck, text: "Assign sales owner" },
            { type: "THEN", icon: CheckSquare, text: "Create follow-up task" },
            { type: "THEN", icon: Mail, text: "Send welcome email" },
            { type: "THEN", icon: BellRing, text: "Notify sales manager" },
        ],
    },
    {
        name: "Proposal follow-through",
        active: true,
        steps: [
            { type: "WHEN", icon: FileText, text: "Opportunity enters Proposal", accent: true },
            { type: "THEN", icon: CheckSquare, text: "Create follow-up in 2 days" },
            { type: "THEN", icon: Bell, text: "Notify deal owner" },
        ],
    },
];

const Automation = () => (
    <section id="automation" data-testid="automation-builder-section" className="bg-[#F7FEF9]/60 py-20 lg:py-28">
        <Container>
            <SectionHeader
                eyebrow="Automation"
                title="Let your CRM do the busywork."
                sub="A visual, no-code rule builder. Set the trigger once — Kryvo handles assignment, tasks, emails and alerts every single time."
            />
            <div className="mt-14 grid gap-6 lg:grid-cols-2">
                {recipes.map((r, ri) => (
                    <Reveal key={r.name} delay={ri * 0.12} className="min-w-0">
                        <div
                            data-testid={ri === 0 ? "automation-builder-canvas" : `automation-builder-canvas-${ri}`}
                            className="h-full rounded-2xl border border-[#E5E7EB] bg-white p-4 shadow-lg shadow-slate-900/[0.04] sm:p-6"
                        >
                            <div className="mb-5 flex items-center justify-between">
                                <p className="font-display text-[15px] font-bold text-[#111827]">{r.name}</p>
                                <span className="flex items-center gap-1.5 rounded-full bg-[#F0FDF4] px-2.5 py-1 text-[10px] font-bold text-[#15803D]">
                                    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#16A34A]" /> Active
                                </span>
                            </div>
                            <div className="grid gap-0">
                                {r.steps.map((s, i) => (
                                    <div key={i} className="relative">
                                        {i > 0 && (
                                            <div className="absolute -top-3 left-[27px] h-3 w-px bg-[#16A34A]/30" />
                                        )}
                                        <div
                                            className={`mb-3 flex items-center gap-3.5 rounded-xl border p-3.5 transition-all hover:shadow-md ${
                                                s.accent
                                                    ? "border-[#16A34A]/30 bg-gradient-to-r from-[#16A34A] to-[#15803D] text-white shadow-md shadow-[#16A34A]/20"
                                                    : "border-[#E5E7EB] bg-white"
                                            }`}
                                        >
                                            <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${s.accent ? "bg-white/15" : "bg-[#F0FDF4]"}`}>
                                                <s.icon className={`h-4 w-4 ${s.accent ? "text-white" : "text-[#16A34A]"}`} />
                                            </span>
                                            <div className="min-w-0">
                                                <p className={`text-[9px] font-bold uppercase tracking-[0.14em] ${s.accent ? "text-white/70" : "text-[#94A3B8]"}`}>
                                                    {s.type}
                                                </p>
                                                <p className={`truncate text-[13px] font-semibold ${s.accent ? "text-white" : "text-[#111827]"}`}>
                                                    {s.text}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </Container>
    </section>
);

export default Automation;
